export default "/template/resource//static/media/img_weipeizhi@2x.6f3d20da.png";